import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { CHECK_MS, NIGHT_KEY, decide, tabJitter, windowOffset } from "@/lib/autoReload";
import { hasUnsavedWork, uploadsInProgress } from "@/lib/unsaved";
import { checkVersion } from "@/lib/version";

const OPENED = Date.now();
const SCROLL_KEY = "cts_auto_reload_scroll";
const EVENTS = ["keydown", "mousemove", "mousedown", "touchstart", "scroll", "wheel"];
const main = () => document.querySelector('[data-testid="main-content"]');

// Internal app only (mounted in AppShell): reloads an idle tab once per night inside the admin-set UK window.
export const AutoReload = () => {
  const [cfg, setCfg] = useState(null);
  const last = useRef(Date.now());
  useEffect(() => { api.get("/settings/auto-reload").then((r) => setCfg(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    const on = () => { last.current = Date.now(); };
    EVENTS.forEach((e) => window.addEventListener(e, on, { passive: true, capture: true }));
    return () => EVENTS.forEach((e) => window.removeEventListener(e, on, { capture: true }));
  }, []);
  useEffect(() => {
    const saved = JSON.parse(sessionStorage.getItem(SCROLL_KEY) || "null");
    sessionStorage.removeItem(SCROLL_KEY);
    if (saved && saved.url === window.location.href) setTimeout(() => main()?.scrollTo(0, saved.top), 1200);
  }, []);
  useEffect(() => {
    if (!cfg?.enabled) return undefined;
    const tick = async () => {
      const now = Date.now();
      if (windowOffset(now, cfg.start, cfg.end) === null) return;
      const d = decide({ now, settings: cfg, openedAt: OPENED, lastActivity: last.current, versionStale: await checkVersion(),
        dirty: hasUnsavedWork(), uploading: uploadsInProgress(), lastNight: sessionStorage.getItem(NIGHT_KEY), jitterMin: tabJitter() });
      console.info(`[auto-reload] ${d.reload ? "reloading" : "skipped"}: ${d.reason}`);
      if (!d.reload) return;
      sessionStorage.setItem(NIGHT_KEY, d.night);
      sessionStorage.setItem(SCROLL_KEY, JSON.stringify({ url: window.location.href, top: main()?.scrollTop || 0 }));
      window.dispatchEvent(new Event("cts:before-auto-reload"));  // lets composers flush their draft autosave
      setTimeout(() => window.location.reload(), 1500);
    };
    tick();
    const id = setInterval(tick, CHECK_MS);
    return () => clearInterval(id);
  }, [cfg]);
  return null;
};
